import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocation,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className=''>
          <footer className="main-footer">
          <div className="footer-top sp-five">
            <div className="container">
              <div className="row">
                <div className="colmun col-xl-4 col-md-6 col-sm-12">
                  <div className="about-colmun">
                    <div className="footer-logo mb-20">
                      <Link to='/'>
                        <img
                          src={require("../../../images/footer-logo.png")}
                          alt=""
                        />
                      </Link>
                    </div>
                    <div className="text">
                    Carrymybaggage.com is a baggage transfer service that provides door-to- door, door-to-airport, and airport-to- door collection and delivery for all kinds of baggage items.
                    </div>
                    <ul style={{paddingLeft:"0px"}} className="social-links mt-30">
                      <li>
                        <a href="#">
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fa fa-vimeo"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fa fa-google-plus"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="colmun col-xl-2 col-md-6 col-sm-12">
                  <div className="service-colmun">
                    <div className="footer-title mb-30">
                      <h6>Help Center</h6>
                    </div>
                    <ul style={{paddingLeft:"0px"}} className="service-list">
                      <li>
                        <a href="#">FAQs</a>
                      </li>
                      <li>
                        <a href="#">Packing Guide</a>
                      </li>
                      <li>
                        <a href="#">Documentation</a>
                      </li>
                      <li>
                        <a href="#">Insurance</a>
                      </li>
                      <li>
                        <a href="#">Privacy Policy</a>
                      </li>
                      <li>
                        <a href="#">Terms and Condition's</a>
                      </li>
                      <li>
                        <a href="#">Sitemap</a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="colmun col-xl-3 col-md-6 col-sm-12">
                  <div className="schedul-colmun">
                    <div className="footer-title mb-30">
                      <h6>Working Hours</h6>
                    </div>
                    <ul style={{paddingLeft:"0px"}} className="schedul-table clearfix">
                      <li>
                        Mon - Friday: <span>9.00AM -5.00PM</span>
                      </li>
                      <li>
                        Saturday: <span>9.00AM -5.00PM</span>
                      </li>
                      <li className="closed">
                        Sunday: <span> Closed</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="colmun col-xl-3 col-md-6 col-sm-12">
                  <div className="contact-colmun">
                    <div className="footer-title mb-30">
                      <h6>Contact</h6>
                    </div>
                    <ul style={{paddingLeft:"0px"}} className="contact-list">
                      <li>
                        <a>
                                              {/* <FontAwesomeIcon className="fa" icon={faLocation} /> */}
                        2nd Floor, Plot No, 269, Phase IV, Udyog Vihar, Sector 18, Gurugram, Haryana 122015                        </a>
                      </li>
                      <li>
                                          {/* <FontAwesomeIcon className="fa" icon={faPhone} /> */}
                    
                        <a>+91-9999136186

</a>
                      </li>
                      <li>
                                          {/* <FontAwesomeIcon className="fa" icon={faLocation} /> */}
                    
                        <a href="#">support@carrymybaggage.com

</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom black-bg">
            <div className="container clearfix">
              <div className="footer-copyright float-left">
                <a href="index.html"></a> &copy; Copyright © 2018 DBB Worldwide
                Pvt. Ltd. All rights reserved.
              </div>
              <ul className="terms-service">
                <li>
                  <a href="#">Terms of Service</a>
                </li>
                <li>
                  <a href="#">Privacy Policy</a>
                </li>
              </ul>
            </div>
          </div>
        </footer>
      <button className="scroll-top scroll-to-target">
        <span className="fa fa-arrow-up"></span>
      </button>
    </div>
  )
}

export default Footer